/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { func, string } from "prop-types";
import { withFacebookLogin, withGoogleLogin, withAppleLogin, withLinkedinLogin } from "@quintype/bridgekeeper-js";
import { connect, useSelector } from "react-redux";
import { parseUrl } from "query-string";
import get from "lodash/get";

import Button from "../../atoms/Button";

import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import "./social-login.m.css";

export const SocialLoginBase = ({ loginOption, setLoginOption, googleAppId, facebookAppId, customCallbackUrl }) => {
  const [redirectUrl, setRedirectUrl] = useState("/");
  const publisherAttributes = useSelector((state) => get(state, ["qt", "config", "publisher-attributes"], {}));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], ""));
  const ssoLoginIsEnable = get(publisherAttributes, ["sso_login", "is_enable"], false);
  const clientId = get(publisherAttributes, ["sso_login", "client_id"], "");

  useEffect(() => {
    const params = parseUrl(currentPath);
    const getCallbackUrl =
      customCallbackUrl || get(params, ["query", "callback_uri"], global.location && global.location.origin);
    const getRedirectUrl =
      get(params, ["query", "redirect_uri"]) || get(publisherAttributes, ["sso_login", "redirect_Url"], "");
    const location = new URL(window.location.href);
    const oauthAuthorize = `${location.origin}/api/auth/v1/oauth/authorize?redirect_uri=${getRedirectUrl}&client_id=${clientId}&callback_uri=${getCallbackUrl}&response_type=code`;
    setRedirectUrl(ssoLoginIsEnable ? oauthAuthorize : `${location.origin}${location.pathname}`);
  }, []);

  const FaceBookLogin = () => {
    const { serverSideLoginPath } = withFacebookLogin({
      scope: "email",
      emailMandatory: true,
      redirectUrl: encodeURIComponent(redirectUrl),
    });
    return (
      <Button color="#3b5998" flat href={serverSideLoginPath} socialButton>
        <span styleName="icon">
          <SvgIconHandler type="facebook" iconStyle={{ color: "#3b5998" }} width="9" height="15" viewBox="0 0 12 21" />
        </span>
        Facebook
      </Button>
    );
  };

  const LinkedinLogin = () => {
    const { serverSideLoginPath } = withLinkedinLogin({
      scope: "email",
      emailMandatory: true,
      redirectUrl: encodeURIComponent(redirectUrl),
    });
    return (
      <Button color="#dd4b39" flat href={serverSideLoginPath} socialButton>
        <span styleName="icon">
          <SvgIconHandler type="linkedin" iconStyle={{ color: "#3b5998" }} width="30" height="30" viewBox="0 0 15 20" />
        </span>{" "}
        LinkedIn
      </Button>
    );
  };

  const GoogleLogin = () => {
    const { serverSideLoginPath } = withGoogleLogin({
      scope: "email",
      emailMandatory: true,
      redirectUrl: encodeURIComponent(redirectUrl),
    });
    return (
      <Button color="#dd4b39" flat href={serverSideLoginPath} className="googleBtn" socialButton>
        <span styleName="icon">
          <img src="/icons/google-icon.svg" width="12" height="12" />
        </span>{" "}
        Google
      </Button>
    );
  };

  const AppleLogin = () => {
    const { serverSideLoginPath } = withAppleLogin(encodeURIComponent(redirectUrl));
    return (
      <Button color="#dd4b39" flat href={serverSideLoginPath} className="appleBtn" socialButton>
        <span styleName="icon">
          <SvgIconHandler type="apple" height="13" width="13" iconStyle={{ color: "#000" }} />
        </span>{" "}
        Apple
      </Button>
    );
  };

  const PhoneEmailLogin = (props) => {
    return (
      <button onClick={() => setLoginOption(props.label)} styleName="loginBtn">
        <span styleName="icon">
          <SvgIconHandler type={props.label} height="15" width="15" iconStyle={{ color: "#000" }} />
        </span>
        <span>{loginOption}</span>
      </button>
    );
  };

  const isSubscriptionUrl = typeof window !== 'undefined' && window.location.pathname === '/subscription';

  return (
    <div styleName="social-login">
      <h3 styleName="title">Tai kirjaudu käyttäen</h3>
      <ul styleName="buttons" style={isSubscriptionUrl ? { marginBottom: '0px' } : {}}>
       {/*  <li styleName="button">
          {loginOption === "Email" ? <PhoneEmailLogin label={"login"} /> : <PhoneEmailLogin label={"phone"} />}
        </li>
       <li styleName="button">
          <FaceBookLogin />
        </li>*/}
        <li styleName="button" style={isSubscriptionUrl ? { marginBottom: '0px' } : {}}>
          <GoogleLogin />
        </li>
        {/*li styleName="button">
          <AppleLogin />
        </li*/}
        {/*<li styleName="button">
          <LinkedinLogin />
        </li>*/}
      </ul>
    </div>
  );
};

SocialLoginBase.propTypes = {
  getCurrentUser: func,
  loginOption: string,
  setLoginOption: func,
  googleAppId: string,
  facebookAppId: string,
  customCallbackUrl: string,
};

const mapStateToProps = (state) => ({
  googleAppId: get(state, ["qt", "config", "publisher-attributes", "google_app_id"], ""),
  facebookAppId: get(state, ["qt", "config", "publisher-attributes", "facebook_app_id"], ""),
});

export const SocialLogin = connect(mapStateToProps, null)(SocialLoginBase);
